export default __webpack_public_path__ + "media/images/favicon/logo-512-5bc6103ff70e0bde36dc5fb7f363d2ff.png";